var React = require('react');

function IconAdminCircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M510.2 67.2c-247.3 0-447.7 200.4-447.7 447.7s200.4 447.7 447.7 447.7 447.7-200.4 447.7-447.7S757.5 67.2 510.2 67.2zm.3 191.8c70.4 0 126.6 56.7 126.6 127.1s-56.4 127.1-126.6 127.1S383.4 456.4 383.4 386s56.8-127 127.1-127zm254.3 511.8H256.4v-58.7c0-84.7 169.5-127.1 254.2-127.1s254.3 42.4 254.3 127.1l-.1 58.7z"}));
}

IconAdminCircleSolid.displayName = "IconAdminCircleSolid";

IconAdminCircleSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconAdminCircleSolid;

IconAdminCircleSolid.default = IconAdminCircleSolid;
